import React from "react";
import Dictionary from "../../components/dictionary/Dictionary";

function DictionaryPage() {
  return <Dictionary />;
}

export default DictionaryPage;
